/* eslint-disable no-undef */ import { createContext, useEffect, useRef, useState } from 'react';
import rosetta from 'rosetta';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
const format = (str, values)=>{
    const regex = /(@{[aA-zZ]+})/gi;
    return str.split(regex).map((part, idx)=>{
        const partMatch = (part.match(regex) || [])[0] || '';
        const partMatch2 = partMatch.match(/@{(.*)}/i);
        const group = partMatch2 === null || partMatch2 === void 0 ? void 0 : partMatch2[1];
        const Component = group && values[group];
        return typeof Component === 'function' ? // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        _jsx(Component, {}, idx) : Component || part;
    });
};
const i18n = rosetta();
export const defaultLanguage = 'br';
export const languages = [
    'br',
    'en',
    'es'
];
export const contentLanguageMap = {
    br: 'pt-BR',
    en: 'en-US',
    es: 'es'
};
export const I18nContext = /*#__PURE__*/ createContext({
    activeLocale: defaultLanguage,
    t: function(_a, _values) {
        for(var _len = arguments.length, _args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
            _args[_key - 2] = arguments[_key];
        }
        return 'Loading';
    },
    Trans: (any)=>any,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    locale: (_locale, _dict)=>{},
    useDateLocale: ()=>undefined,
    activeDict: null
});
// default language
i18n.locale(defaultLanguage);
export default function I18n(param) {
    let { children, locale, lngDict } = param;
    const activeLocaleRef = useRef(locale || defaultLanguage);
    const getDateLocale = async ()=>(await (import("date-fns/locale/".concat(contentLanguageMap[activeLocaleRef.current || defaultLanguage], "/index.js")).catch((_noop)=>null) || {})).default;
    const [, setTick] = useState(0);
    const firstRender = useRef(true);
    const activeDict = i18n.table(activeLocaleRef.current);
    const tHelper = function(key) {
        let values = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
            args[_key - 2] = arguments[_key];
        }
        const normalizedKey = [
            key.toString()
        ];
        return activeDict && i18n.t(normalizedKey, ...args) ? format(i18n.t(normalizedKey, ...args), values) : format([
            key,
            ...args
        ].toString(), values);
    };
    const i18nWrapper = {
        activeLocale: activeLocaleRef.current,
        activeDict,
        t: tHelper,
        Trans: (param)=>{
            let { children, ...props } = param;
            const trans = tHelper;
            return _jsx(_Fragment, {
                children: trans(children.join(''), {
                    ...props
                })
            });
        },
        locale: (locale, dict)=>{
            i18n.locale(locale);
            activeLocaleRef.current = locale;
            if (dict) {
                i18n.set(locale, dict);
            }
            // force rerender to update view
            setTick((tick)=>tick + 1);
        },
        useDateLocale: ()=>{
            const [dateLocale, setDateLocale] = useState();
            useEffect(()=>{
                const setupDateLocale = async ()=>{
                    setDateLocale(await getDateLocale());
                };
                setupDateLocale();
            });
            return dateLocale;
        }
    };
    // for initial SSR render
    if (locale && firstRender.current === true) {
        firstRender.current = false;
        i18nWrapper.locale(locale, lngDict);
    }
    // when locale is updated
    useEffect(()=>{
        if (locale) {
            i18nWrapper.locale(locale, lngDict);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        lngDict,
        locale
    ]);
    return _jsx(I18nContext.Provider, {
        value: i18nWrapper,
        children: children
    });
}
